// Color mode toggle: light/dark, auto by default, manual override sticks.
// Supports any number of toggle controls marked with [data-color-mode-toggle].
(function () {
  var STORAGE_KEY = 'gp-color-mode';
  var root = document.documentElement;

  function buttons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-color-mode-toggle]'));
  }

  function currentMode() {
    return root.getAttribute('data-color-mode') === 'dark' ? 'dark' : 'light';
  }

  function applyMode(mode) {
    root.setAttribute('data-color-mode', mode);
    buttons().forEach(function (button) {
      button.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      var label = button.querySelector('[data-color-mode-label]');
      if (label) label.textContent = mode === 'dark' ? 'Dark' : 'Light';
    });
  }

  // Sync control state with whatever the blocking init script already set.
  applyMode(currentMode());

  document.addEventListener('click', function (e) {
    var button = e.target.closest ? e.target.closest('[data-color-mode-toggle]') : null;
    if (!button) return;
    var next = currentMode() === 'dark' ? 'light' : 'dark';
    applyMode(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (err) {
      // localStorage unavailable (private browsing etc) - mode just won't persist across visits.
    }
  });

  // Dark is the house default (see color-mode-init), so the OS setting no
  // longer drives the mode. Only an explicit tap on the toggle changes it,
  // and that choice is remembered.
})();
